// src/App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Tours from './components/Tours';
import Packages from './components/Packages';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Chooseus from './components/Chooseus';


function App() {
  return (
    <Router>
      <Navbar />
      <Hero />
      <About />
      <Packages />
      <Tours />
      <Chooseus />
      <Footer />
    </Router>
  );
}

export default App;
